// extracted by mini-css-extract-plugin
module.exports = {"featuredAdWrapper":"_3pwUWzm_YFU7F1PO-isCAC","headline":"_2NM_nx57wYawJoSULt2lAc","subtitle":"_1PX3xLQ6AVR_oTP_fwRDd_","featuredAdContent":"vEj84nD5nkwv4bCzh7hsS"};